import { NAVIGATOR_STATUS, PostMessageType } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { NavigatorContext, NavigatorContextProps } from '@/contexts/navigator'

import { usePostMessage } from './usePostMessage'

interface UseNavigatorProps {
  handleConversationStarted: () => Promise<void>
  onGoingConversation: NavigatorContextProps['onGoingConversation']
  handleConversationEnded: () => Promise<void>
  messages: NavigatorContextProps['messages']
  navigator: NavigatorContextProps['navigator']
  setNavigator: NavigatorContextProps['setNavigator']
  loading: NavigatorContextProps['loading']
  setLoading: NavigatorContextProps['setLoading']
  isPending: boolean
  pendingMessage: NavigatorContextProps['pendingMessage']
  setPendingMessage: NavigatorContextProps['setPendingMessage']
}

export default function useNavigator(): UseNavigatorProps {
  const { onGoingConversation, setOnGoingConversation, messages, navigator, setNavigator, loading, setLoading, pendingMessage, setPendingMessage } =
    useContext(NavigatorContext)
  const { sendPostMessage } = usePostMessage()

  const handleConversationStarted = async () => {
    setOnGoingConversation(true)
  }

  const handleConversationEnded = async () => {
    await sendPostMessage(PostMessageType.NAVIGATOR_CONVERSATION_ENDED, { conversationId: navigator.healthNavigator.conversationId! })
    setOnGoingConversation(false)
  }

  return {
    handleConversationStarted,
    onGoingConversation,
    handleConversationEnded,
    messages,
    navigator,
    setNavigator,
    loading,
    setLoading,
    isPending: navigator.status === NAVIGATOR_STATUS.PENDING,
    pendingMessage,
    setPendingMessage
  }
}
